if (!customElements.get("m-announcement-bar")) {
  class MAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) return;
      this.initSlider();
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const slideContainer = this.querySelector(".swiper-container");
      if (slideContainer) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          autoplay: autoplay
            ? {
                delay: parseInt(autoplaySpeed) * 1000,
              }
            : false,
          loop: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
          on: {
            init: function () {
              const activeSlide = this.slides[this.activeIndex];
              const content = activeSlide.querySelector('.m-announcement-bar__content');
              if (content) {
                slideContainer.style.width = content.offsetWidth + 'px';
                slideContainer.style.transition = 'width 0.3s ease';
              }
            },
            slideChangeTransitionStart: function () {
              const activeSlide = this.slides[this.activeIndex];
              const content = activeSlide.querySelector('.m-announcement-bar__content');
              if (content) {
                slideContainer.style.width = content.offsetWidth + 'px';
              }
            }
          }
        });
      }
    }
  }

  customElements.define("m-announcement-bar", MAnnouncementBar);
}
